<div class="action-icon">
  <app-state-view [state]="state">
    <loading-state>
      <div class="action-icon__container">
        <app-dots-spinner class="action-icon__spinner"></app-dots-spinner>
      </div>
    </loading-state>
    <empty-state></empty-state>
    <error-state>
      <div class="action-icon__container">
        <mat-icon class="action-icon__error-icon">warning</mat-icon>
      </div>
    </error-state>
    <content-state>
      <div class="action-icon__container" (click)="onClick($event)" (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()">
        <ng-content></ng-content>
      </div>
    </content-state>
  </app-state-view>
</div>
